<template lang="pug">
  form(v-if="formData" @submit="submit($event, 'estadisticas')")
    h2 POBLACIÓN TOTAL
    .md-layout.md-gutter(v-if="formData.poblacion")
      .md-layout-item.md-size-100
        md-field(:class="getValidationClass('formData.poblacion.total')", md-clearable)
          label Cantidad de Población
          md-input(type='number', v-model='formData.poblacion.total', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.poblacion.total.required') Requerido
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.poblacion.hombres')", md-clearable)
          label Porcentajes de hombres
          md-input(type='number', v-model='formData.poblacion.hombres', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.poblacion.hombres.required') Requerido
          span.md-error(v-if='!$v.formData.poblacion.hombres.between')
            | El valor debe estar entre {{$v.formData.poblacion.hombres.$params.between.min}} y {{$v.formData.poblacion.hombres.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.poblacion.mujeres')", md-clearable)
          label Porcentajes de mujeres
          md-input(type='number', v-model='formData.poblacion.mujeres', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.poblacion.mujeres.required') Requerido
          span.md-error(v-if='!$v.formData.poblacion.mujeres.between')
            | El valor debe estar entre {{$v.formData.poblacion.mujeres.$params.between.min}} y {{$v.formData.poblacion.mujeres.$params.between.max}}
    md-divider
    h4 Población por grupo de edad (Población en porcentaje)
    .md-layout.md-gutter(v-if="formData.poblacion")
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.poblacion[`0-14`]')", md-clearable)
          label Entre 0 y 14 años
          md-input(type='number', v-model="formData.poblacion['0-14']", :disabled='sending', :step="0.1")
          span.md-error(v-if="!$v.formData.poblacion['0-14'].required") Requerido
          span.md-error(v-if="!$v.formData.poblacion['0-14'].between")
            | El valor debe estar entre {{$v.formData.poblacion['0-14'].$params.between.min}} y {{$v.formData.poblacion['0-14'].$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.poblacion[`15-64`]')", md-clearable)
          label Entre 15 y 64 años
          md-input(type='number', v-model='formData.poblacion[`15-64`]', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.poblacion[`15-64`].required') Requerido
          span.md-error(v-if='!$v.formData.poblacion[`15-64`].between')
            | El valor debe estar entre {{$v.formData.poblacion[`15-64`].$params.between.min}} y {{$v.formData.poblacion[`15-64`].$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.poblacion[`65`]')", md-clearable)
          label Población de más de 65 años
          md-input(type='number', v-model='formData.poblacion[`65`]', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.poblacion[`65`].required') Requerido
          span.md-error(v-if='!$v.formData.poblacion[`65`].between')
            | El valor debe estar entre {{$v.formData.poblacion[`65`].$params.between.min}} y {{$v.formData.poblacion[`65`].$params.between.max}}
    md-divider
    h4 Categoría de ocupación de población ocupada (Población en porcentaje)
    .md-layout.md-gutter(v-if="formData.ocupacion")
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.ocupacion.dependiente')", md-clearable)
          label Dependiente
          md-input(type='number', v-model='formData.ocupacion.dependiente', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.ocupacion.dependiente.required') Requerido
          span.md-error(v-if='!$v.formData.ocupacion.dependiente.between')
            | El valor debe estar entre {{$v.formData.ocupacion.dependiente.$params.between.min}} y {{$v.formData.ocupacion.dependiente.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.ocupacion.independiente')", md-clearable)
          label Independiente
          md-input(type='number', v-model='formData.ocupacion.independiente', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.ocupacion.independiente.required') Requerido
          span.md-error(v-if='!$v.formData.ocupacion.independiente.between')
            | El valor debe estar entre {{$v.formData.ocupacion.independiente.$params.between.min}} y {{$v.formData.ocupacion.independiente.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.ocupacion.noInformado')", md-clearable)
          label No informó su condición
          md-input(type='number', v-model='formData.ocupacion.noInformado', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.ocupacion.noInformado.required') Requerido
          span.md-error(v-if='!$v.formData.ocupacion.noInformado.between')
            | El valor debe estar entre {{$v.formData.ocupacion.noInformado.$params.between.min}} y {{$v.formData.ocupacion.noInformado.$params.between.max}}
    h2 DATOS DE VIVIENDAS PARTICULARES
    md-field(:class="getValidationClass('formData.viviendas.total')", md-clearable v-if="formData.viviendas")
      label Viviendas particulares ocupadas con personas presentes
      md-input(type='number', v-model='formData.viviendas.total', :disabled='sending', :step="0.1")
      span.md-error(v-if='!$v.formData.viviendas.total.required') Requerido
    h4 Acceso a TIC (Tecnología de la Información y Comunicación)
    |               Porcentaje de viviendas con acceso a:
    .md-layout.md-gutter(v-if="formData.viviendas")
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.viviendas.conAccesoA.telefono')", md-clearable)
          label Teléfonos
          md-input(type='number', v-model='formData.viviendas.conAccesoA.telefono', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.viviendas.conAccesoA.telefono.required') Requerido
          span.md-error(v-if='!$v.formData.viviendas.conAccesoA.telefono.between')
            | El valor debe estar entre {{$v.formData.viviendas.conAccesoA.telefono.$params.between.min}} y {{$v.formData.viviendas.conAccesoA.telefono.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.viviendas.conAccesoA.celular')", md-clearable)
          label Celulares
          md-input(type='number', v-model='formData.viviendas.conAccesoA.celular', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.viviendas.conAccesoA.celular.required') Requerido
          span.md-error(v-if='!$v.formData.viviendas.conAccesoA.celular.between')
            | El valor debe estar entre {{$v.formData.viviendas.conAccesoA.celular.$params.between.min}} y {{$v.formData.viviendas.conAccesoA.celular.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.viviendas.conAccesoA.computadora')", md-clearable)
          label Computadoras
          md-input(type='number', v-model='formData.viviendas.conAccesoA.computadora', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.viviendas.conAccesoA.computadora.required') Requerido
          span.md-error(v-if='!$v.formData.viviendas.conAccesoA.computadora.between')
            | El valor debe estar entre {{$v.formData.viviendas.conAccesoA.computadora.$params.between.min}} y {{$v.formData.viviendas.conAccesoA.computadora.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.viviendas.conAccesoA.internet')", md-clearable)
          label Computadoras con internet
          md-input(type='number', v-model='formData.viviendas.conAccesoA.internet', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.viviendas.conAccesoA.internet.required') Requerido
          span.md-error(v-if='!$v.formData.viviendas.conAccesoA.internet.between')
            | El valor debe estar entre {{$v.formData.viviendas.conAccesoA.internet.$params.between.min}} y {{$v.formData.viviendas.conAccesoA.internet.$params.between.max}}
    md-divider
    br
    h4 Condición de propiedad de vivienda
    |               Porcentajes:
    .md-layout.md-gutter(v-if="formData.viviendas && formData.viviendas.condicion")
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.viviendas.condicion.propia')", md-clearable)
          label Es propia
          md-input(type='number', v-model='formData.viviendas.condicion.propia', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.viviendas.condicion.propia.required') Requerido
          span.md-error(v-if='!$v.formData.viviendas.condicion.propia.between')
            | El valor debe estar entre {{$v.formData.viviendas.condicion.propia.$params.between.min}} y {{$v.formData.viviendas.condicion.propia.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.viviendas.condicion.alquilada')", md-clearable)
          label Es alquilada
          md-input(type='number', v-model='formData.viviendas.condicion.alquilada', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.viviendas.condicion.alquilada.required') Requerido
          span.md-error(v-if='!$v.formData.viviendas.condicion.alquilada.between')
            | El valor debe estar entre {{$v.formData.viviendas.condicion.alquilada.$params.between.min}} y {{$v.formData.viviendas.condicion.alquilada.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.viviendas.condicion.prestada')", md-clearable)
          label Es prestada
          md-input(type='number', v-model='formData.viviendas.condicion.prestada', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.viviendas.condicion.prestada.required') Requerido
          span.md-error(v-if='!$v.formData.viviendas.condicion.prestada.between')
            | El valor debe estar entre {{$v.formData.viviendas.condicion.prestada.$params.between.min}} y {{$v.formData.viviendas.condicion.prestada.$params.between.max}}
      .md-layout-item.md-small-size-100
        md-field(:class="getValidationClass('formData.viviendas.condicion.noInformado')", md-clearable)
          label No informado
          md-input(type='number', v-model='formData.viviendas.condicion.noInformado', :disabled='sending', :step="0.1")
          span.md-error(v-if='!$v.formData.viviendas.condicion.noInformado.required') Requerido
          span.md-error(v-if='!$v.formData.viviendas.condicion.noInformado.between')
            | El valor debe estar entre {{$v.formData.viviendas.condicion.noInformado.$params.between.min}} y {{$v.formData.viviendas.condicion.noInformado.$params.between.max}}
    md-divider

    md-button.md-raised.md-primary(v-show="!isCreateView" type="submit" ref="saveButton") Guardar

</template>

<script>
import { between } from 'vuelidate/lib/validators'
import projectFormMixin from '@/mixins/project-form.js'

export const statisticInitialValue = {
  ocupacion: {
    dependiente: 0,
    independiente: 0,
    noInformado: 0
  },
  poblacion: {
    '0-14': 0,
    '15-64': 0,
    '65': 0,
    hombres: 0,
    mujeres: 0,
    total: 0
  },
  viviendas: {
    conAccesoA: {
      celular: 0,
      computadora: 0,
      internet: 0,
      telefono: 0
    },
    condicion: {
      alquilada: 0,
      noInformado: 0,
      prestada: 0,
      propia: 0
    },
    total: 0
  }
}

export default {
  mixins: [ projectFormMixin ],
  props: {
    isCreateView: {
      type: Boolean,
      default: false
    },
    customValidations: {
      type: Object,
      default: () => ({})
    }
  },
  validations () {
    return {
      formData: {
        ocupacion: {
          dependiente: {
            between: between(0.0, 100.0)
          },
          independiente: {
            between: between(0.0, 100.0)
          },
          noInformado: {
            between: between(0.0, 100.0)
          }
        },
        poblacion: {
          '0-14': {
            between: between(0.0, 100.0)
          },
          '15-64': {
            between: between(0.0, 100.0)
          },
          '65': {
            between: between(0.0, 100.0)
          },
          hombres: {
            between: between(0.0, 100.0)
          },
          mujeres: {
            between: between(0.0, 100.0)
          },
          total: { }
        },
        viviendas: {
          conAccesoA: {
            celular: {
              between: between(0.0, 100.0)
            },
            computadora: {
              between: between(0.0, 100.0)
            },
            internet: {
              between: between(0.0, 100.0)
            },
            telefono: {
              between: between(0.0, 100.0)
            }
          },
          condicion: {
            alquilada: {
              between: between(0.0, 100.0)
            },
            noInformado: {
              between: between(0.0, 100.0)
            },
            prestada: {
              between: between(0.0, 100.0)
            },
            propia: {
              between: between(0.0, 100.0)
            }
          },
          total: { }
        },
        ...this.customValidations
      }
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/edit-project-form-style'
</style>
